import { useEffect, useRef } from "react";
import "./benefitsSection.css";
import CardWithText from "./CardWithText";
import { isMobile } from "../utility/constand";

const BenefitsSection = () => {
  const cardsRef = useRef(null);
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!cardsRef.current || !scrollContainerRef.current) return;

      if (isMobile) return;

      const cards = cardsRef.current.querySelectorAll(".benefit-card");
      const scrollTop = scrollContainerRef.current.scrollTop;
      const maxScrollDistance = 100;
      const scrollProgress = Math.max(
        0,
        Math.min(1, scrollTop / maxScrollDistance)
      );

      // Apply slide-up effect to second row cards (indices 3, 4, 5)
      cards.forEach((card, index) => {
        if (index >= 3) {
          const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);
          const easedProgress = easeOutCubic(scrollProgress);
          const maxTranslateY = -10;
          const translateY = maxTranslateY * easedProgress;

          card.style.transform = `translateY(${translateY}%)`;
          card.style.zIndex = easedProgress > 0.1 ? "15" : "10";
        }
      });
    };

    const scrollContainer = scrollContainerRef.current;
    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", handleScroll, {
        passive: true,
      });
      handleScroll(); // Trigger once on mount
    }

    return () => {
      if (scrollContainer) {
        scrollContainer.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  return (
    <div className="benefits-section-container">
      {/* Header Section */}
      <div className="header-section">
        <h3 className="benefit-section-heading">
          Why Choose <span className="brand-text">BeFiSc? </span>
        </h3>
      </div>
      {/* Cards Section */}
      <div className="scrollable-container" ref={scrollContainerRef}>
        <div className="cards-section" ref={cardsRef}>
          {/* First card */}
          <CardWithText
            title={<><span style={{ color: '#6D2FEC' }}>API-First </span>from Day 1</>}
            description="Plug in and go with simple docs, Postman collections and developer-ready endpoints for fast deployment."
            imageSrc="/images/Illustration.svg"
            bgColor="#FFF9F1"
            borderColor="#FFE4C4"
            cardBoxColor="#FF9D28"
            height="468px"
          />
          {/* second card */}
          <CardWithText
            title={<> Built for <span style={{ color: '#6D2FEC' }}>Fraud </span>Prevention</>}
            description="Catch forged documents, fake identities, and hidden risks before they slip into your system."
            imageSrc="/images/Illustration (1).svg"
            bgColor="#E8EEFF"
            borderColor="#DAE3FF"
            cardBoxColor="#002EBC"
            height="446px"
          />
          {/* third card */}
          <CardWithText
            title={<>Fair, Transparent <span style={{ color: '#6D2FEC' }}>Pricing</span></>}
            description="Clear and predictable pricing with no paywalls, fine print or hidden costs."
            imageSrc="/images/Illustration (6).svg"
            bgColor="#F4FFE7"
            borderColor="#F1FFDF"
            cardBoxColor="#94C358"
            height="468px"
          />
          {/* fourth card */}
          <CardWithText
            title={<>Trusted by <span style={{ color: '#6D2FEC' }}> 150+ </span>Companies</>}
            description="Enabling secure, high-uptime API operations for organisations across industries and regions."
            imageSrc="/images/Illustration (3).svg"
            bgColor="#FFE7E6"
            borderColor="FFEAE9"
            cardBoxColor="#A41E18"
            height="446px"
            top="36px"
          />
          {/* fifth card */}
          <CardWithText
            title={<><span style={{ color: '#6D2FEC' }}>24x7 </span>Dedicated Developer Support</>}
            description="Round-the-clock technical guidance for smooth integration and reliable uptime."
            imageSrc="/images/Illustration (2).svg"
            bgColor="#E2FBFF"
            borderColor="#E1FAFF"
            cardBoxColor="#00C7EB"
            height="468px"
            top="36px"
          />
          {/* sixth card */}
          <CardWithText
            title={<>Modular <span style={{ color: '#6D2FEC' }}>Product </span>Suite</>}
            description="Start with one API and expand to a complete suite for identity, fraud and verification."
            imageSrc="/images/Illustration (5).svg"
            bgColor="#FBE8FF"
            borderColor="#F9E1FF"
            cardBoxColor="#9700BC"
            height="446px"
            top="36px"
          />
        </div>
      </div>
    </div>
  );
};

export default BenefitsSection;
